(function () {
document.querySelectorAll('.btn--loader').forEach(function(button) {
    // Wrap button content in a span.
    button.innerHTML = "<span>".concat(button.innerHTML, "</span>");
});

})();
//# sourceMappingURL=button.min.js.map
